module.exports = __webpack_public_path__ + "static/media/drop-down-black.b5673436.svg";